interface PageHeaderProps {
  title: string
  description?: string
}

export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-primary/10 to-background py-12 md:py-16">
      <div className="absolute top-20 right-[10%] w-72 h-72 bg-primary/5 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-10 left-[5%] w-96 h-96 bg-purple-200/20 rounded-full blur-3xl -z-10" />
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">{title}</h1>
        {description && (
          <p className="mt-4 text-xl text-muted-foreground max-w-3xl mx-auto">{description}</p>
        )}
      </div>
    </div>
  )
}
